import React, { FC } from 'react';
import { Badge } from 'antd';

type Props = {
  status: string;
};

const Status: FC<Props> = ({ status }) => {
  const getBadgeStatus = (): 'success' | 'processing' | 'default' | 'error' | 'warning' => {
    switch (status) {
      case 'Completed':
      case 'Assessment Completed':
        return 'success';
      case 'Waiting':
      case 'Waiting for Assessment':
        return 'warning';
      case 'In Progress':
      case 'Assessment in Progress':
        return 'processing';
      case 'Failed':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <span>
      <Badge status={getBadgeStatus()} />
      {status}
    </span>
  );
};

export default Status;
